import { Webhook } from "../common/model/objectTypes";
import { WEBHOOK_INFO, WEBHOOK_PRODUCT_INFO, WEBHOOK_SPECIFICATION } from "../utils/webhook/webhookDescriptions";
import { accessedOrganizerNotificationBody, engagementLetterSignedAndOrganizerCompletedBody, questionnaireCompletedBody, sourceDocumentUploadedBody, ssoTestConnectionBody, } from "../utils/webhook/webhookObjects";
import { accessedOrganizerNotificationJsonResponse, engagementLetterSignedJsonResponse, OrganizerCompletedJsonResponse, questionnaireCompletedJsonResponse, sourceDocumentUploadedJsonResponse, testConnectionJsonResponse } from "../utils/webhook/webhookResponseJson";

const engagementLetterSigned: Webhook = {
    name: "Engagement Letter Signed",
    productInfo: WEBHOOK_PRODUCT_INFO.SSO,
    webhookInfo: WEBHOOK_INFO.SSO,
    webhookSpecifications: WEBHOOK_SPECIFICATION.SSO.engagementLetterSigned,
    testConnectionJson: testConnectionJsonResponse,
    testConnectionBody: ssoTestConnectionBody,
    responseBody: engagementLetterSignedAndOrganizerCompletedBody,
    jsonResponse: engagementLetterSignedJsonResponse,
}

const organizerCompleted: Webhook = {
    name: "Organizer Completed",
    productInfo: WEBHOOK_PRODUCT_INFO.SSO,
    webhookInfo: WEBHOOK_INFO.SSO,
    webhookSpecifications: WEBHOOK_SPECIFICATION.SSO.organizerCompleted,
    testConnectionJson: testConnectionJsonResponse,
    testConnectionBody: ssoTestConnectionBody,
    responseBody: engagementLetterSignedAndOrganizerCompletedBody,
    jsonResponse: OrganizerCompletedJsonResponse,
}

const sourceDocumentUploaded: Webhook = {
    name: "Source Document Uploaded",
    productInfo: WEBHOOK_PRODUCT_INFO.SSO,
    webhookInfo: WEBHOOK_INFO.SSO,
    webhookSpecifications: WEBHOOK_SPECIFICATION.SSO.sourceDocumentUploaded,
    testConnectionJson: testConnectionJsonResponse,
    testConnectionBody: ssoTestConnectionBody,
    responseBody: sourceDocumentUploadedBody,
    jsonResponse: sourceDocumentUploadedJsonResponse,
}

const accessedOrganizerNotification: Webhook = {
    name: "Accessed Organizer Notification",
    productInfo: WEBHOOK_PRODUCT_INFO.SSO,
    webhookInfo: WEBHOOK_INFO.SSO,
    webhookSpecifications: WEBHOOK_SPECIFICATION.SSO.accessedOrganizerNotification,
    testConnectionJson: testConnectionJsonResponse,
    testConnectionBody: ssoTestConnectionBody,
    responseBody: accessedOrganizerNotificationBody,
    jsonResponse: accessedOrganizerNotificationJsonResponse,
}

const questionnaireCompleted: Webhook = {
    name: "Questionnaire completed",
    productInfo: WEBHOOK_PRODUCT_INFO.SSO,
    webhookInfo: WEBHOOK_INFO.SSO,
    webhookSpecifications: WEBHOOK_SPECIFICATION.SSO.engagementLetterSigned,
    testConnectionJson: testConnectionJsonResponse,
    testConnectionBody: ssoTestConnectionBody,
    responseBody: questionnaireCompletedBody,
    jsonResponse: questionnaireCompletedJsonResponse,
}

export const getContent = (webhookName: string) => {
    switch (webhookName) {
        case "Engagement Letter Signed":
            return engagementLetterSigned;
        case "Organizer Completed":
            return organizerCompleted;
        case "Source Document Uploaded":
            return sourceDocumentUploaded;
        case "Accessed Organizer Notification":
            return accessedOrganizerNotification;
        case "Questionnaire completed":
            return questionnaireCompleted;
    }
}